import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import { sectionPaddingClasses } from '../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers';

export default function TextBlockSlice(props) {
        const {
            title,
            button_url,
            button_title,
            text_align,
            margins,
            description
        } = props.content;

        return (
            <section className={sectionPaddingClasses(margins)}>
                <div className={`container ${text_align && 'text-' + text_align}`}>
                    <div className="row">
                        <div className="col-12">
                            {title && <h3 className="heading-two">{title}</h3>}
                            {description && description.length > 0 && RichText.render(description)}
                            {
                                button_url &&
                                button_title &&
                                <a className="theme-button" href={button_url}>
                                    {button_title}
                                </a>
                            }
                        </div>
                    </div>
                </div>
            </section>
        )
}
TextBlockSlice.propTypes = {
    content: PropTypes.shape({
        title: PropTypes.string,
        text_align: PropTypes.string,
        type: PropTypes.string,
        button_url: PropTypes.string,
        button_title: PropTypes.string,
        description: PropTypes.arrayOf(PropTypes.object),
    })
}



// WEBPACK FOOTER //
// src/client/components/slices/TextBlockSlice.js